import BaseAPI from './base/base-api';

class ServiceRegisPayAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'PaymentAPI';
	controllerName = 'serviceregis';
}

export default new ServiceRegisPayAPI();
